/* eslint-disable no-param-reassign */
import { notification } from 'antd';
import { randomBytes } from 'crypto';
import debug from 'debug';

import { API_ENDPOINTS } from 'common/constants';
import { GET_ITEMS, UPDATE_ITEM, DELETE_ITEM, UPDATE_ITEMS_ORDER } from 'admin/constants';

const log = debug('app:actions:items');

export function getItems(categoryId) {
	return async dispatch => {
		return dispatch({
			type: GET_ITEMS.START,
			url: API_ENDPOINTS.getItems,
			payload: { categoryId },
			onSuccess: res => dispatch({ type: GET_ITEMS.SUCCESS, payload: res.data }),
			onFail: () => dispatch({ type: GET_ITEMS.FAIL }),
		});
	};
}

export function updateItem(categoryId, data) {
	return dispatch => {
		let { id } = data;
		let payload = null;
		const isCreateMode = !id;

		const onSuccess = () => {
			notification.success({
				message: isCreateMode ? 'Created' : 'Updated',
				description: isCreateMode
					? `${data.name} has been successfuly created`
					: `${data.name} has been successfuly updated`,
			});
			dispatch({ type: UPDATE_ITEM.SUCCESS, payload: { ...data, id, categoryId } });
		};
		const onFail = err => {
			log('updateItem FAIL', { message: 'Error!', description: err.message });
			notification.error({ message: 'Error!', description: err.message });
			dispatch({ type: UPDATE_ITEM.FAIL });
		};

		if (isCreateMode) {
			id = randomBytes(16).toString('hex');
		}

		payload = { ...data, id, categoryId };

		dispatch({
			type: UPDATE_ITEM.START,
			url: API_ENDPOINTS.updateItem,
			payload,
			secure: true,
			onSuccess,
			onFail,
		});
	};
}

export function updateItemsOrder(items) {
	return async dispatch => {
		await dispatch({
			type: UPDATE_ITEMS_ORDER.START,
			url: API_ENDPOINTS.updateItemsOrder,
			payload: items,
			secure: true,
			onSuccess: res => dispatch({ type: UPDATE_ITEMS_ORDER.SUCCESS, payload: res.data }),
			onFail: () => dispatch({ type: UPDATE_ITEMS_ORDER.FAIL }),
		});
	};
}

export function deleteItem(data) {
	return dispatch => {
		const onSuccess = () => {
			notification.success({
				message: 'Deleted',
				description: `${data.name} has been successfuly deleted`,
			});
			dispatch({ type: DELETE_ITEM.SUCCESS, payload: { ...data } });
		};
		const onFail = err => {
			notification.error({ message: 'Error!', description: err.message });
			dispatch({ type: DELETE_ITEM.FAIL });
		};

		dispatch({
			type: DELETE_ITEM.START,
			url: API_ENDPOINTS.deleteItem,
			payload: { ...data },
			secure: true,
			onSuccess,
			onFail,
		});
	};
}
